import { render, staticRenderFns } from "./ItemHorario.vue?vue&type=template&id=267707ec&"
import script from "./ItemHorario.vue?vue&type=script&lang=js&"
export * from "./ItemHorario.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports